/**
 * Сколько шторок сейчас на экране. Нужно тому, кто открывает шторку сам, без
 * касания покупателя (подсказка об оценке заказа): поверх чужой шторки свою
 * не кладём — HIG sheets.md › Display only one sheet at a time.
 */
let count = 0
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

/** Шторка открылась; вернёт, чем отметить её закрытие. */
export function sheetOpened(): () => void {
  count += 1
  emit()
  return () => {
    count -= 1
    emit()
  }
}

export function anySheetOpen(): boolean {
  return count > 0
}

/** Подписка для `useSyncExternalStore`. */
export function subscribeSheets(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
